import { render, staticRenderFns } from "./locationVisitsTable.vue?vue&type=template&id=379f4ba4"
import script from "./locationVisitsTable.vue?vue&type=script&lang=js"
export * from "./locationVisitsTable.vue?vue&type=script&lang=js"
import style0 from "./locationVisitsTable.vue?vue&type=style&index=0&id=379f4ba4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports